<template>
  <div class="molecule-reason-selector">
    <h3 :id="`reason-title-${radioGroupName}`" class="molecule-reason-selector__title">{{ title }}</h3>
    <div class="molecule-reason-selector__options" role="radiogroup" :aria-labelledby="`reason-title-${radioGroupName}`">
      <div v-for="option in options" :key="option.key" class="molecule-reason-selector__option" @click="selectReason(option.key)" @keydown.enter.prevent="selectReason(option.key)">
        <AtomRadioButton class="molecule-reason-selector__radio" :label="option.name" :value="option.key" :name="radioGroupName" :checked="selectedReason === option.key" :tabindex="0" />
      </div>
    </div>
  </div>
</template>

<script>
  import AtomRadioButton from "../atoms/AtomRadioButton.vue";

  export default {
    name: "MoleculeReasonSelector",
    components: {
      AtomRadioButton,
    },
    props: {
      title: {
        type: String,
        default: "Motivo",
      },
      options: {
        type: Array,
        default: () => [],
      },
      selectedReason: {
        type: String,
        default: "",
      },
      radioGroupName: {
        type: String,
        default: "reasonGroup",
      },
      showMessage: {
        type: Boolean,
        default: true,
      },
    },
    emits: ["reason-selected"],
    methods: {
      selectReason(reasonKey) {
        this.$emit("reason-selected", reasonKey);
      },
    },
  };
</script>

<style lang="scss">
  .molecule-reason-selector {
    &__title {
      margin: 0 0 12px 0;
      font-size: 16px;
      font-weight: 500;
      font-family: $newFont_medium;
      text-transform: capitalize;
      color: #3d3d3d;
    }

    &__options {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 12px 20px;
    }

    &__option {
      cursor: pointer;
    }

    &__message {
      font-size: 12px;
      color: #666;
      margin-top: 8px;
      margin-bottom: 0;
    }
    &__radio {
      .radioButton__label {
        font-size: 15px;
        font-family: $newFont_regular;
        font-weight: 400;
      }

      .radioButton__input:focus-visible {
        outline: 2px solid $primary_color;
        outline-offset: 2px;
      }
    }
  }
</style>
